import AllCitiesContainer from './AllCitiesContainer';

export default AllCitiesContainer;
